import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Paragraph = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: ${props => (props.theme.isPortrait ? 15 : 16)}px;
  line-height: 20px;
  max-width: 364px;
  width: ${props => (props.theme.isPortrait ? 85 : 25.3)}vw;
  color: #fff;
  margin: 0;
`;

export default function Desc({ text }) {
  return <Paragraph>{text}</Paragraph>;
}

Desc.propTypes = {
  text: PropTypes.string.isRequired,
};
